export default {
  data () {
    return {
      chart: null
    }
  },
  props: {
    minHeight: {
      type: Number,
      required: false,
      default: 380
    }
  },
  computed: {
    chartId () {
      return 'chart-' + this._uid
    },
    outerId () {
      return 'chart-outer-' + this._uid
    }
  },
  watch: {
    chartData: {
      deep: true,
      handler: function (newVal, oldVal) {
        if (JSON.stringify(newVal) !== JSON.stringify(oldVal)) {
          this.init()
        }
      }
    }
  },
  mounted () {
    this.init()
  }
}



// WEBPACK FOOTER //
// ./src/components/charts/mixins/chart.js